function tp_blog_posts() {
  const tp_blog_post_swiper = document.querySelector('.tp-blog-posts__content');
  if (!tp_blog_post_swiper) return;
  const spaceBetween = Number(tp_blog_post_swiper.dataset.spaceBetween);
  const slidesPerView = Number(tp_blog_post_swiper.dataset.desktop);
  const loop = tp_blog_post_swiper.dataset.loop === "true";
  const autoplay = tp_blog_post_swiper.dataset.autoplay === "true";

  var tp_blog_pos = new Swiper('.tp-blog-posts__content', {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: loop,
    autoplay: autoplay,
    navigation: {
      nextEl: ".swiper-next-blog-post",
      prevEl: ".swiper-prev-blog-post",
    },
    pagination: {
      clickable: true,
      el: ".swiper-pagination-blog-post",
    },
    breakpoints: {
      410: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: slidesPerView,
        slidesPerGroup: slidesPerView,
        spaceBetween: spaceBetween
      },
    }
  });
}
tp_blog_posts();
document.addEventListener("shopify:section:load", tp_blog_posts);
document.addEventListener("shopify:section:unload", tp_blog_posts);